import {bodyLock} from "./module";

export function showNavigation() {
    const _window = this._window;
    const _document = this._document;
    const _mainWrap = this.mainWrap;
    const menuBtn = _document.querySelector(".burger");
    let scrolled = _window.scrollY || _window.pageYOffset;
    let contentPosition = 0;
    let flag = false;

    function toggleNav() {
        flag = !flag;
        if(flag) {
            contentPosition = scrolled;
            _mainWrap.classList.add("show-nav");
            bodyLock.lockBody();
        } else {
            _mainWrap.classList.remove("show-nav");
            _document.querySelector("html, body").scrollTop = contentPosition;
            bodyLock.unlockBody();
        }
    }
	
    menuBtn && menuBtn.addEventListener("click", function () {
        toggleNav();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/show-navigation.js